import {
  IRoadshowsCollectionFilters,
  IRoadshowsFilters,
} from '@/creditflowresearch/application/Roadshows/vo/IRoadshowsPayload';
import { IRoadshowsResponse } from '@/creditflowresearch/application/Roadshows/vo/IRoadshowsResponse';

const initRoadshowsFilters: IRoadshowsFilters = {
  includedProductIds: [],
  includedRegionIds: [],
  includedSectorIds: [],
  includedSubsectorIds: [],
  includedIndustryIds: [],
  includedSubindustryIds: [],
  includedIssuerIds: [],
  includedParentIds: [],
  includedDealIds: [],
  includedMarketIds: [],
  includedSegmentIds: [],
};

const initRoadshowsTileCollectionFilters: IRoadshowsCollectionFilters = {
  search: '',
  sortBy: 'issuerName',
  sortOrder: 'asc',
  page: 1,
  perPage: 10,
};

const initRoadshowsCollectionFilters: IRoadshowsCollectionFilters = {
  ...initRoadshowsTileCollectionFilters,
  perPage: 25,
};

const initRoadshowsData: IRoadshowsResponse = {
  totalCount: 0,
  collection: [],
};

export {
  initRoadshowsFilters,
  initRoadshowsTileCollectionFilters,
  initRoadshowsCollectionFilters,
  initRoadshowsData,
};
